import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IssueReportArea } from 'src/app/backend-client/models/Backend/Core/Infrastructure/Aggregates/App/issue-report-area';
import { Role } from 'src/app/backend-client/models/Backend/Core/Infrastructure/Aggregates/Identity/role';
import { MxIdentityService } from './mx.identity.service';

/** A hibajelzés-dialógus előre kitöltött mezői (a felső sáv „Hiba bejelentése” az aktuális útvonalat adja át). */
export interface SzIssueReportPrefill {
  area?: IssueReportArea;
  page?: string | null;
}

const REPORTER_ROLES = [Role.Pharmacy, Role.PharmacyBasic, Role.PartnerProgramPharmacy];

/**
 * A „Hibajelzés” dialógus egy példányban él a vázban (main.component), bárhonnan nyitható:
 * a Hibajelzés oldal „Új bejelentés” gombjáról és a felső sáv „?” menüjéből. Sikeres beküldés után
 * a `created$` jelez, hogy a lista frissülhessen.
 */
@Injectable({ providedIn: 'root' })
export class SzIssueReportDialogService {
  readonly open$ = new Subject<SzIssueReportPrefill>();
  readonly created$ = new Subject<number>();

  constructor(private identityService: MxIdentityService) {}

  /** Csak a patikai szerepkörök jelenthetnek hibát; az admin a bejelentéseket kezeli. */
  get canReport(): boolean {
    const role = Number(this.identityService.accountValue?.role);
    return REPORTER_ROLES.includes(role);
  }

  open(prefill: SzIssueReportPrefill = {}) {
    if (!this.canReport) return;
    this.open$.next(prefill);
  }

  notifyCreated(id: number) {
    this.created$.next(id);
  }
}
